import React from 'react';
import { CardTiles } from './view/cardTiles';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'CardTiles', 
  itemElt: (item, cmsOption) => <CardTiles item={item} cmsOption={cmsOption} />
}